
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Stop extends Vue {
  @Prop(Array) public services: [];
}
